import { render, staticRenderFns } from "./ButtonPalettePanel.vue?vue&type=template&id=33458318&scoped=true&"
import script from "./ButtonPalettePanel.vue?vue&type=script&lang=ts&"
export * from "./ButtonPalettePanel.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonPalettePanel.vue?vue&type=style&index=0&id=33458318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33458318",
  null
  
)

component.options.__file = "ButtonPalettePanel.vue"
export default component.exports